// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const moduleWrapper = "ModuleWrapper__moduleWrapper__vUMd4";
export const flexLayout = "ModuleWrapper__flexLayout__IZps-";
export const noPadding = "ModuleWrapper__noPadding__vR4HW";
export const header = "ModuleWrapper__header__Bqql3";
export const blockName = "ModuleWrapper__blockName__+DirL";
export const title = "ModuleWrapper__title__5uqnL";
export const subtitle = "ModuleWrapper__subtitle__HR7Gf";
export const rightArrow = "ModuleWrapper__rightArrow__ST4hY";
export const headerInner = "ModuleWrapper__headerInner__0nBw0";
export const tooltipIconWrapper = "ModuleWrapper__tooltipIconWrapper__CE0bT TooltipIcon__tooltipIconWrapper__oUGNC";
export const withChevron = "ModuleWrapper__withChevron__X3elS";